/*** IMPORTS FROM imports-loader ***/


module.exports = require('es6-promise').Promise;




//////////////////
// WEBPACK FOOTER
// ../~/es6-promise-promise/index.js
// module id = 30
// module chunks = 3